module.exports = __webpack_public_path__ + "img/ic-firmware.83753918.svg";